import { Link } from 'react-router-dom';

const footerLinks = {
  服务导航: [
    { label: '平台介绍', path: '/categories' },
    { label: '使用教程', path: '/categories' },
    { label: '优惠活动', path: '/categories' },
    { label: '用户评价', path: '/categories' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '发展历程', path: '/about' },
    { label: '荣誉资质', path: '/about' },
    { label: '联系方式', path: '/about' },
  ],
  帮助支持: [
    { label: '常见问题', path: '/about' },
    { label: '使用教程', path: '/articles' },
    { label: '用户反馈', path: '/about' },
    { label: '服务协议', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-2xl font-heading font-bold text-primary-500">jiuyou</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                jiuyou是您值得信赖的首选平台，提供全方位的智能服务解决方案，让生活与工作更加高效便捷。
              </p>
              <div className="flex items-center space-x-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-lg" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-lg" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="邮箱">
                  <i className="ri-mail-line text-lg" />
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">{title}</h4>
                <ul className="space-y-3">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 jiuyou. All rights reserved. | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}